export default __webpack_public_path__ + "static/media/hubzoneCertified.1f370ae0.jpeg";